<script setup lang="ts">
import NavbarLogo from '@/components/navbar/NavbarLogo.vue'
import NavbarMenu from '@/components/navbar/NavbarMenu.vue'
import { useAppStore } from '@/stores/app.store.ts'
import { computed } from 'vue'
import NavbarMenuButtonAvatar from '@/components/navbar/NavbarMenuButtonAvatar.vue'
import NavbarMenubar from '@/components/navbar/NavbarMenubar.vue'
import NavbarNotification from '@/components/navbar/NavbarNotification.vue'
import NavbarBreadcrumb from '@/components/navbar/NavbarBreadcrumb.vue'

const appStore = useAppStore()
const isLogin = computed(() => appStore.isLogin)
</script>

<template>
  <header
    :class="isLogin ? 'bg-stone-100/50 dark:bg-stone-900/50 transition-colors duration-150' : ''"
    class="px-4 py-2"
  >
    <div class="flex justify-between">
      <navbar-logo></navbar-logo>
      <div class="flex gap-2 self-center">
        <navbar-menu></navbar-menu>
        <navbar-menu-button-avatar v-if="isLogin"></navbar-menu-button-avatar>
      </div>
    </div>

    <div v-if="isLogin" class="mt-2">
      <navbar-menubar></navbar-menubar>
    </div>
  </header>

  <div v-if="isLogin">
    <navbar-notification></navbar-notification>
    <navbar-breadcrumb></navbar-breadcrumb>
  </div>
</template>

<style scoped></style>
